module.exports = __webpack_public_path__ + "img/2.1c7f1d4b.webp";